import styled from "@emotion/styled"
import { Link, Typography } from "@mui/material"
import * as api from "api"
import { memo } from "react"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    border: 2px solid ${(p) => p.theme.colors.duskBlue};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    position: relative;
    padding-top: 40px;
    padding-bottom: 12px;
    height: 100%;
  `,
  Icon: styled.img`
    position: absolute;
    width: 51px;
    height: 51px;
    top: -23px;
    right: 12px;
  `,
  Name: styled(Typography)`
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    padding: 0 12px;
    color: ${(p) => p.theme.colors.black};
    border: none;
  `,
  Subject: styled.span`
    font-size: 25px;
    color: ${(p) => p.theme.colors.duskBlue};
    display: block;
    margin-top: 12px;
  `,
  Description: styled(Typography)`
    color: ${(p) => p.theme.colors.black};
    padding: 12px;
    font-size: 14px;
  `,
  Separator: styled.div`
    width: 100%;
    border-bottom: 2px dashed #21508a;
    margin-top: auto;
  `,
  Link: styled(Link)`
    margin: 12px;
    display: block;
    width: auto;
    button {
      margin: 0;
      width: 100%;
    }
  `,
  GetButton: styled(Shared.Button)`
    height: 35px;
    font-size: 14px;
    margin: 12px;
    width: auto;
    ${(p) => p.theme.breakpoints.down("sm")} {
      width: auto;
    }
  `,
  Legal: styled(Typography)`
    color: ${(p) => p.theme.colors.cloudyBlue};
    padding: 12px;
    padding-top: 0;
    font-size: 14px;
  `,
}

type PromotionProps = { benefit: api.Benefit; onBenefitClick: () => void }

const Promotion = ({ benefit, onBenefitClick }: PromotionProps) => {
  return (
    <Styled.Wrapper>
      <Styled.Icon src="/benefit-icon.png" alt="" />
      <Styled.Name variant="h3">
        {benefit.name}
        <Styled.Subject>{benefit.subject}</Styled.Subject>
      </Styled.Name>

      <Styled.Description>{benefit.description}</Styled.Description>
      <Styled.Separator />
      {benefit.link ? (
        <Styled.Link
          href={benefit.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Styled.GetButton variant="contained">אני רוצה הטבה</Styled.GetButton>
        </Styled.Link>
      ) : (
        <Styled.GetButton variant="contained" onClick={onBenefitClick}>
          אני רוצה הטבה
        </Styled.GetButton>
      )}

      <Styled.Legal>{benefit.legalizationComment}</Styled.Legal>
    </Styled.Wrapper>
  )
}

export default memo(Promotion)
